import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styles from './JoinCommunitySection.module.scss';
import imgHands from '../../../assets/images/Landing/manos-vela-comunidad.jpg';
import { useAuthContext } from '../../../context/AuthContext';

export const JoinCommunitySection: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { isAuthenticated, user } = useAuthContext();

    const isProfessional = isAuthenticated && user?.type_account === 'professional';
    const isConsultant = isAuthenticated && user?.type_account === 'patient';

    const handleJoinClick = () => {
        if (isConsultant) {
            navigate('/contact');
        } else {
            navigate('/register');
        }
    };

    return (
        <section className={styles['join-section']}>
            <div className={styles['container']}>
                <div className={styles['card']}>
                    <div className={styles['content']}>
                        <p className={styles['eyebrow']}>{t('landing.joinCommunity.eyebrow', 'SUMARTE')}</p>
                        <h2 className={styles['title']}>{t('landing.joinCommunity.title', 'Crecer en comunidad también es una forma de cuidar')}</h2>
                        <p className={styles['description']}>{t('landing.joinCommunity.description', 'Queremos reunir profesionales que no solo compartan formación o trayectoria, sino también una forma más amplia, consciente y colaborativa de comprender la salud.')}</p>
                        {isProfessional ? (
                            <button className={styles['btn-join']} onClick={() => navigate('/dashboard')}>
                                {t('landing.heroSection.goDashboard', 'Ir a mi panel')}
                            </button>
                        ) : (
                            <button className={styles['btn-join']} onClick={handleJoinClick}>
                                {t('landing.joinCommunity.cta', 'Quiero ser parte del equipo')}
                            </button>
                        )}
                    </div>
                    <div className={styles['image-container']}>
                        <img src={imgHands} alt="Manos unidas" className={styles['image']} />
                        <div className={styles['image-overlay']}></div>
                    </div>
                </div>
            </div>
        </section>
    );
};
